<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-3xl mx-auto bg-base-100 p-8 md:p-12 rounded-3xl shadow-xl animate-fade-in-up">
      
      <h1 class="text-3xl md:text-4xl font-extrabold text-base-content mb-8 border-b border-base-200 pb-4">Privacy Policy</h1>
      
      <div class="space-y-6 text-base-content/80 leading-relaxed">
        <p><strong>Last Updated: July 2026</strong></p>
        
        <p>At Aanza, we take your privacy seriously. This policy explains how we collect, use, and protect your information when you use our restaurant management SaaS and digital QR menus.</p>
        
        <h2 class="text-xl font-bold text-primary mt-8 mb-2">1. Information We Collect</h2>
        <ul class="list-disc list-inside space-y-2 ml-4">
          <li><strong>From Diners:</strong> Order history, basic contact info (if provided), and browsing behavior on digital menus.</li>
          <li><strong>From Restaurants:</strong> Menu details, stock levels, employee management records, and business contact information.</li>
        </ul>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">2. How We Use Your Information</h2>
        <p>We use this data to provide a seamless interactive ordering experience, process payments securely, and help restaurant owners reduce staff dependency by optimizing their operations.</p>

        <h2 class="text-xl font-bold text-primary mt-8 mb-2">3. Data Security</h2>
        <p>We implement modern security measures to protect both restaurant operational data and end-user ordering information from unauthorized access.</p>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
